import { Component } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';

import { ExpirationModes } from 'app/shared/model/lists/expiration-modes.model';
import { ListFieldBaseComponent } from 'app/shared/model/lists/list-field-base-component.model';
import { ListsHandler } from 'app/shared/model/lists/lists-handler.model';
import { UserService } from 'app/user/user.service';

@Component({
  templateUrl: './list-field-date-expiry.component.html',
  styleUrls: ['./list-field-date-expiry.component.scss'],
  selector: 'cc-list-field-date-expiry',
})
export class ListFieldDateExpiryComponent extends ListFieldBaseComponent {
  readonly expirationModes = ExpirationModes;
  name: string;
  timezone: string;

  constructor(private readonly userService: UserService) {
    super();
    this.name = `${this.property?.id}date-expiry-input`;
  }

  ngOnInit() {
    this.timezone = this.getTimezone();
  }

  getTimezone() {
    const timezone = [this.userService.getCurrentUser().timezone, (moment as any).tz.guess()].find(Boolean);
    return timezone;
  }

  getPropertyValue() {
    return String(this.property?.value ?? '');
  }

  onPropertyUpdated(dateValue: NgbDateStruct) {
    this.property._dateValue = dateValue;
    this.property.value = ListsHandler.getTimezoneAwareProperty(dateValue, this.property, this.timezone);

    this.propertyUpdated.emit({ value: this.property.value });
  }
}
